import { render, staticRenderFns } from "./MailParams.vue?vue&type=template&id=a0e60f7e&scoped=true&"
import script from "./MailParams.vue?vue&type=script&lang=js&"
export * from "./MailParams.vue?vue&type=script&lang=js&"
import style0 from "./MailParams.vue?vue&type=style&index=0&id=a0e60f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e60f7e",
  null
  
)

export default component.exports